export default __webpack_public_path__ + "static/media/lead.7c3002c0.svg";